<template>
  <div>
    <div class="top_title">
      <el-row :gutter="24">
        <el-col :span="15">
          <div class="block">
            <el-image :src="src1" style="height:100%;width:90%;"></el-image>
          </div>
        </el-col>
        <el-col :span="9" style="text-align: left">
          <div class="block">
            <p style="font-size: x-large">
              <b>BooleanDA文档小助手</b>
              <el-image :src="src2" style="height: 25px;width:50px;"></el-image>
            </p>
            <p><span class="span-text-bold">文档转换：</span>PDF转双层等10个功能</p>
            <p><span class="span-text-bold">批量转换：</span>一键操作</p>
            <p><span class="span-text-bold">支持格式：</span>Word/Excel/PDF等文档</p>
            <p><span class="span-text-bold">更多功能：</span>批量添加印章，核对页码等</p>
<!--            <div>-->
<!--              <div class="pao">免费试用1个月</div>-->
<!--              <el-button type="primary" icon="el-icon-download" round @click="handle_download">&nbsp;立即下载</el-button>-->
<!--            </div>-->
<!--            <p></p>-->
<!--            <div class="span-text-mini">-->
<!--              <p>软件大小：{{ fileSize }}MB</p>-->
<!--              <p>支持系统：Windows10 &nbsp;| &nbsp; Windows11</p>-->
<!--              <p>更新日期：{{ fileDate }} &nbsp;版本：V{{ fileVersion }}</p>-->
<!--            </div>-->
            <br>
            <br>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-carousel height="580px" width="100%">
      <el-carousel-item v-for="item in imgList" :key="item">
        <el-image :src=item style="height: 100%;width: 100%;"></el-image>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
// 当使用模板绑定src时
// 不可以使用@，无法解析；也无法找到assets目录，可以import进来
// <img :src="@/assets/img/login/user.png">
import img1 from '@/assets/images/back_top.gif'
import img2 from '@/assets/images/hot.png'
import img_list1 from '@/assets/images/back/back_blue_01.jpg'
import img_list2 from '@/assets/images/back/back_blue_02.jpg'
import img_list3 from '@/assets/images/back/back_blue_03.jpg'
import { getVersion, getDownload } from '@/api/index'
import { urlParam } from '@/utils/url'

export default {
  name: 'TopTitle2',
  props: {
    msg: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      src1: img1,
      src2: img2,
      imgList: [
        img_list1,
        img_list2,
        img_list3
      ],
      fileSize: '',
      fileDate: '',
      fileVersion: '',
      fileUrl: '',
      fileId: '',
      param: {},
      oname: 'EXE001'
    }
  },
  created() {
    // 获取链接的参数
    this.param = urlParam
    // 设置产品类型，默认exe001
    if (this.param.oname !== undefined) {
      this.oname = this.param.oname
    }
    this.handle_getVersion()
  },
  methods: {
    handle_download() {
      // this.visible = true
      // const filePath = baseURL + 'download/BooleanDA文档小助手_V1.3.0.0.rar'
      const filePath = this.fileUrl
      const link = window.document.createElement('a')
      link.style.display = 'none'
      // link.href = url
      link.href = filePath
      // link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      this.$message({
        message: '恭喜你，文件已开始下载！',
        type: 'success'
      })
      //
      // Math.random()*(max-min)+min),生成10-100的随机数
      const timestamp = new Date().getTime().toString() + Math.round(Math.random() * 90 + 10).toString()
      var params = {
        'id': this.fileId,
        'timestamp': timestamp
      }
      getDownload(params).then((res) => {
        console.log('更新返回成功')
        console.log(res)
        if (res['code'] === 200) {
          console.log('更新成功' + res['data'])
        } else {
          // 提示信息
          console.log('fail')
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    handle_getVersion() {
      const timestamp = new Date().getTime().toString() + Math.round(Math.random() * 90 + 10).toString()
      var params = {
        'id': this.oname,
        'timestamp': timestamp
      }
      getVersion(params).then((res) => {
        console.log('获取版本返回数据')
        console.log(res)
        if (res['code'] === 200) {
          console.log('获取数据成功')
          console.log(res.data)
          this.fileVersion = res['data']['fileVersion']
          this.fileUrl = res['data']['fileUrl']
          this.fileSize = res['data']['fileSize']
          this.fileDate = res['data']['fileDate']
          this.fileId = 'EXE001V' + this.fileVersion.replaceAll('.', '')
        } else {
          // 提示信息
          console.log('fail')
        }
      }).catch((error) => {
        console.log(error)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
.text-big{
  font-size: large;
}
.top_title{
  top:120px;
  left: 10%;
  margin: 0 auto;
  height: 500px;
  width: 80%;
  z-index: 19;
  position: absolute;
  color: #f2f8f5;
}
.el-button--primary {
  display: block;
  color: #FFF;
  background-color: rgba(0, 63, 255, 1);
  border-color: rgba(0, 63, 255, 1);
  box-shadow: 1px 10px 20px rgba(242, 243, 248, 0.5);
  line-height: 34px;
  padding: 0 20px;
  height: 70px;
  width: 280px;
  font-size: 23px;
  font-weight: bold;
}
.el-button--primary:focus,
.el-button--primary:hover {
  color: #FFF;
  background-color: #1E90FF;
  border-color: #1E90FF;
  line-height: 34px;
  padding: 0 20px;
  height: 70px;
  width: 280px;
  font-size: 25px;
}
.el-button--primary:active {
  color: #FFF;
  background-color: #1E90FF;
  border-color: #1E90FF;
  line-height: 34px;
  padding: 0 20px;
  height: 70px;
  width: 280px;
  font-size: 23px;
}
.span-text-bold{
  font-weight: bold;
  font-size: 20px;
}
.span-text-mini{
  font-weight: bold;
  font-size: 12px;
}
.pao{
  //margin: 20px auto;
  margin-left: 130px;
  margin-bottom: -10px;
  position: relative;
  width: 100px;
  height: 24px;
  color: #fff;
  font-size: 10px;
  line-height: 24px;
  text-align: center;
  border: 1px solid #fc0327;
  border-radius: 5px;
  background: #fc0327;
}
.pao::after{
  content: '';
  position: absolute;
  width: 0;
  height: 0;

  left: 15px;
  bottom: -8px;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #fc0327;
}

</style>
